<div class="container-banner-images" style="position: relative;">
  <div class="loader-animations">
    <span class="loaders-skeleton"> </span>
  </div>
  <div class="image-banner skeleton-animation" style="padding-top: 40%;"></div>
</div>
